import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';
import { Tag } from '../tag/tag.interface';

export default {
   async getFilteredByTenant({
      name,
      page,
      tenant_id,
      cancelToken,
   }: {
      name?: string;
      page: number;
      tenant_id?: number;
      cancelToken?: CancelToken;
   }) {
      return await api
         .get('/pool', {
            params: {
               include: 'tenant,candidatesCount',
               'fields[pools]': 'name,description',
               'filter[search]': name,
               'filter[tenant_id]': tenant_id,
               per_page: 40,
               page: page,
               sort: '-updated_at',
            },
            cancelToken: cancelToken,
         })
         .then((response) => {
            return response.data;
         });
   },
   async postNotification(
      pool_id: number,
      body: { medium_type: string; type: string; message: string; start_date: string; end_date: string; candidate_ids: Array<number> },
   ) {
      return await api.post(`/pool/${pool_id}/notification`, body).then((response) => {
         return response.data;
      });
   },
   async postCandidatePoolTagsBulk({ pool_id, body }: { pool_id: number; body: { candidate_pool_ids: Array<number>; tags: Array<Tag> } }) {
      return await api
         .post(`pool/${pool_id}/candidate-pool-tag/bulk`, body, { params: { include: 'all_tags.tag_type,tags.tag_type' } })
         .then((response) => response?.data);
   },
};
